import React from "react";

const NotFoundPage = () => {
  return (
    <div style={{height: '500px'}} className="flex items-center justify-center">Página não encontrada!</div>
  );
};

export default NotFoundPage;
